import { accountSettings, AccountSettingState } from "@pjs/user-domain";
import { filter, map, Observable } from "@pjs/observables";
import { errorNotice, successNotice } from "@pjs/core-ui";
import { IStateNotice } from "../interfaces/IStateNotice";
import { userUiI18n } from "../../i18n/UserUiI18n.const";

export const createAccountSettingNotices = (): Observable<IStateNotice> => {
    const document = accountSettings.getDocument();
    return document.latestModel.state.pipe(
        filter((state) => {
            return state.descriptor === AccountSettingState.SaveFailed || state.descriptor === AccountSettingState.SaveSuccess;
        }),
        map((state): IStateNotice => {
            if (state.descriptor === AccountSettingState.SaveSuccess) {
                return {
                    type: successNotice,
                    ariaLabel: userUiI18n.getString("settings_view.notices.a11y.has_saved"),
                    message: userUiI18n.getString("settings_view.notices.has_saved"),
                    actionLogMessage: userUiI18n.getString("settings_view.notices.logger.save_success")
                };
            }

            return {
                type: errorNotice,
                ariaLabel: userUiI18n.getString("settings_view.notices.a11y.has_save_error"),
                message: userUiI18n.getString("settings_view.notices.has_save_error"),
                actionLogMessage: userUiI18n.getString("settings_view.notices.logger.save_failed")
            };
        })
    );
};
